import { View } from "lucide-react";
import { useNavigate } from "react-router-dom";

function ViewPresentationButton({ presentationId }) {
  const navigate = useNavigate();

  const handlePreview = () => {
    navigate(`/preview-presentation/${presentationId}`);
  };

  return (
    <div>
      <button
        onClick={handlePreview}
        className="px-4 py-2 bg-lightPurple hover:bg-purpleColor text-sm text-white rounded-lg shadow hover:scale-105 transition flex gap-2 items-center"
      >
        <View className="w-4 h-4" />
        <span>Preview</span>
      </button>
    </div>
  );
}

export default ViewPresentationButton;